import HomeIcon from '@material-ui/icons/Home';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import FolderSpecialIcon from '@material-ui/icons/FolderSpecial';
import BusinessIcon from '@material-ui/icons/Business';
import AssignmentIcon from '@material-ui/icons/Assignment';
import LocalHospital from '@material-ui/icons/LocalHospital';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

import { ShellNavConfig } from '../shell';
import { PRODUCT_LANDING_PATH } from '../../utils/authRedirect';
import { Project } from '../projects/types';
import { KNOWLEDGE_BASES } from './registry';

type DashboardNavInput = {
  translateShell: (key: string) => string;
  translateProjects: (key: string) => string;
  projects: Project[];
  /** Org Admin is for organization admins; everyone else must not see it. */
  showOrgAdmin: boolean;
};

export const createDashboardNav = ({
  translateShell,
  translateProjects,
  projects,
  showOrgAdmin,
}: DashboardNavInput): ShellNavConfig => ({
  brand: {
    title: translateShell('brand.title'),
    short: translateShell('brand.short'),
    homePath: PRODUCT_LANDING_PATH,
    workspaceLabel: translateShell('workspace'),
  },

  entries: [
    {
      kind: 'link',
      id: 'home',
      label: translateShell('nav.home'),
      icon: HomeIcon,
      path: PRODUCT_LANDING_PATH,
    },

    /*
     * Clicking the Projects label continues to open /projects.
     * The dropdown displays real backend projects.
     */
    {
      kind: 'projects-link',
      id: 'projects-root',
      label: translateShell('nav.projects'),
      icon: FolderSpecialIcon,
      path: '/projects',

      projects: projects
        .filter(project => !project.deleted)
        .map(project => ({
          id: project.id,
          label: project.name,

          pill: {
            label: project.role,
            tone: 'accent' as const,
          },

          children: [
            {
              id: `${project.id}-test-case-generation`,
              label: translateShell('nav.testCaseGeneration'),
              path: `/dashboard/${project.id}/test-case-generation`,
              icon: PlaylistAddCheckIcon,
            },
          ],
        })),
    },

    ...(showOrgAdmin
      ? [
          {
            kind: 'link' as const,
            id: 'org-admin',
            label: translateShell('nav.orgAdmin'),
            icon: BusinessIcon,
            path: '/org-admin',
          },
        ]
      : []),
    {
      kind: 'group',
      id: 'knowledge-bases',
      label: translateShell('nav.knowledgeBases'),
      icon: LibraryBooks,
      count: KNOWLEDGE_BASES.reduce((sum, kb) => sum + kb.documents.length, 0),
      children: KNOWLEDGE_BASES.map(kb => ({
        id: kb.id,
        label: translateProjects(kb.name),
        path: `/dashboard/knowledge-bases/${kb.id}`,
        pill: {
          label: String(kb.documents.length),
        },
      })),
    },
    {
      kind: 'link',
      id: 'requirements-lifecycle',
      label: translateShell('nav.requirements'),
      icon: AssignmentIcon,
      path: '/requirements',
    },
    {
      kind: 'link',
      id: 'requirement-doctor',
      label: translateShell('nav.requirementDoctor'),
      icon: LocalHospital,
      path: '/requirement-doctor',
    },
  ],
});
